<div class="email-link" (click)="sendMail()">
    <ng-content></ng-content>
</div>